import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'regimen-expiry-banner',
  imports: [],
  templateUrl: './regimen-expiry-banner.component.html',
  styles: [`:host { display: block }`]
})

export class RegimenExpiryBannerComponent {
  @Output() buttonClick = new EventEmitter<void>();
  @Input() regimenExpiryBannerData: any;

  constructor(
  ) {}

  handleClick(): void {
    this.buttonClick.emit();
  }
}
